<template>
    <div v-if="ticket">
        <b-card>
            <span>{{ ticket.barcode }}</span>
            <span v-for="(item, index) in ticket.draw_items" :key="index">{{ item }}</span>
        </b-card>
        <b-card>
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th>#</b-th>
                        <b-th>{{ 'choice' | lang }}</b-th>
                        <b-th>{{ 'amount' | lang }}</b-th>
                        <b-th>{{ 'win' | lang }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(count, index) in ticket.counts" :key="index">
                        <b-td>{{ index + 1 }}</b-td>
                        <b-td>
                            <span v-for="(item, index) in count.items" :key="index">{{ item }}</span>
                        </b-td>
                        <b-td>{{ ticket.amount_formatted | currency }}</b-td>
                        <b-td>{{ count.amount | currency }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
    </div>
    <div v-else>
        <fa-icon icon="circle-notch" size="4x" spin></fa-icon>
    </div>
</template>

<script>
import Axios from "axios";

export default {
    props: ['ticketId'],

    data() {
        return {
            ticket: undefined,
        };
    },

    methods: {
        async fetch() {
            try {
                const params = {
                    ticket_id: this.ticketId,
                    raw: true,
                };

                const { data: res } = await Axios.get(Config.route.combinations, { params });

                this.ticket = res.data;

            } catch (err) {
                console.error(err);
            }
        }
    },

    watch: {
        ticketId(id, previousId) {
            if (id != previousId) {
                this.fetch();
            }
        },
    },

    created() {
        this.fetch();
    },
}
</script>